import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var StarSvg = function StarSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12 2.249 3.665 6.288L22 10.122l-4.219 4.751 1.053 7.376L12 19.092 5.166 22.25l1.053-7.376L2 10.123l6.335-1.586zm0 2.738L9.233 9.735l-4.691 1.173 3.132 3.527-.785 5.499L12 17.573l5.111 2.36-.785-5.498 3.132-3.527-4.691-1.173z",
    clipRule: "evenodd"
  }));
};
export var Star = function Star(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: StarSvg
  }));
};